"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _grey = _interopRequireDefault(require("@material-ui/core/colors/grey"));

var _misc = require("../../misc");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = (0, _core.withStyles)(function (_ref) {
  var palette = _ref.palette,
      typography = _ref.typography;
  return {
    popover: {
      '& .MuiPopover-paper': {
        boxShadow: "0 ".concat((0, _misc.pxToRem)(1), " ").concat((0, _misc.pxToRem)(3), " rgba(0,0,0,.1)")
      },
      '& .MuiPickersCalendarHeader': {
        '&-dayLabel': {
          color: palette.primary.main
        },
        '&-transitionContainer': {
          height: typography.h3.lineHeight,
          '& .MuiTypography-body1': _objectSpread({}, typography.h3, {
            color: palette.primary.main
          })
        },
        '&-iconButton': {
          color: palette.primary.main
        }
      },
      '& .MuiPickersDay': {
        '&-day': {
          color: palette.primary.dark
        },
        '&-daySelected': {
          backgroundColor: palette.primary.main,
          color: palette.common.white,
          fontWeight: 'bold'
        },
        '&-dayDisabled': {
          color: _grey["default"]['400']
        }
      },
      '& .MuiPickersModal-dialogAction': {
        color: palette.primary.light
      }
    }
  };
});

exports["default"] = _default;